module.exports = __webpack_public_path__ + "img/pos_s1_icon5.dd7e370d.png";